export function fmtDate(iso) {
  if (!iso) return null;
  try {
    const d = new Date(iso.length <= 10 ? iso + "T00:00:00" : iso);
    if (isNaN(d)) return iso;
    return d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}

export function relFromNow(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d)) return null;
  const diff = d - new Date();
  const days = Math.round(diff / 86400000);
  if (days < 0) {
    const a = Math.abs(days);
    if (a === 0) return "today";
    if (a < 7) return `${a} day${a > 1 ? "s" : ""} ago`;
    if (a < 60) return `${Math.round(a / 7)} week${Math.round(a / 7) > 1 ? "s" : ""} ago`;
    return `${Math.round(a / 30)} month${Math.round(a / 30) > 1 ? "s" : ""} ago`;
  }
  if (days === 0) return "today";
  if (days < 14) return `in ${days} days`;
  if (days < 60) return `in ${Math.round(days / 7)} weeks`;
  return `in ${Math.round(days / 30)} months`;
}
